import { ServiceHandler } from '../../../utils/api.utils';
import type { Skill, SkillDetail } from '../types';

export const getSkills = ServiceHandler<unknown, { skills: Skill[] }>({
  url: '/api/chat-agent/v1/skills',
});

export const getInvokableSkills = ServiceHandler<
  { params: { agent_id: string; invokable: boolean } },
  { skills: Skill[] }
>({
  url: '/api/chat-agent/v1/skills',
});

export const getSkill = ServiceHandler<unknown, SkillDetail>({
  url: '/api/chat-agent/v1/skills/:skillId',
});
